import http from './_http'

const ruleTotalCount = {
  get: () => http.get(`api/v3/dashboard/rule_count`)
}

const ruleWeekCount = {
  get: () => http.get(`/api/v3/dashboard/rule_date_count`)

}

const licenseTotalCount = {
  get: () => http.get(`api/v3/dashboard/license_count`)
}

const summary = {
  get: () => http.get(`api/v3/dashboard/summary`)
}

const welcome = {
  ruleTotalCount, ruleWeekCount, licenseTotalCount, summary
}

export default welcome
export {ruleTotalCount, ruleWeekCount, licenseTotalCount, summary}
